module.exports = __webpack_public_path__ + "static/media/Safe-T15.aca8a145.jpg";